import { FC } from "react";
import { PropertyGroupSplitBy } from "views/property-groups-configuration/types";
import { propertyGroupTitleMap } from "views/property-groups-configuration/constants";
import { getStateLabel } from "utils/stateCodes";
import { plural } from "pluralize";
import { OptionButton } from "./OptionButton";

const noOptionsMessageMap = {
  [PropertyGroupSplitBy.OWNER]:
    "No owners available. Type a new owner name and press Enter to add",
  [PropertyGroupSplitBy.MARKET]:
    "No markets available. Type a new market name and press Enter to add",
  default: "No options available"
};

interface BoomPropertiesOptionsListProps {
  options: string[];
  inputValue: string;
  selectedOptions: string[];
  disabledOptions: string[];
  currentStep: PropertyGroupSplitBy;
  optionsWithSegmentMap?: Record<string, string>;
  segmentName?: string;
  isLastStep?: boolean;
  onOptionSelect: (option: string) => void;
}

export const BoomPropertiesOptionsList: FC<BoomPropertiesOptionsListProps> = ({
  options,
  inputValue,
  selectedOptions,
  disabledOptions,
  currentStep,
  optionsWithSegmentMap,
  segmentName,
  isLastStep,
  onOptionSelect
}) => {
  const isStateMode = currentStep === PropertyGroupSplitBy.STATE;

  const filteredOptions = options.filter((option) =>
    isStateMode
      ? getStateLabel(option)
          .toLowerCase()
          .includes(inputValue.toLowerCase()) ||
        option.toLowerCase().includes(inputValue.toLowerCase())
      : (option || "").toLowerCase().includes(inputValue.toLowerCase())
  );

  if (options.length === 0)
    return (
      <div className="py-3 px-4 text-xs text-content-300 text-center">
        {noOptionsMessageMap[currentStep]}
      </div>
    );

  if (filteredOptions.length === 0)
    return (
      <div className="py-3 px-4 text-xs text-content-300 text-center">
        No {plural(propertyGroupTitleMap[currentStep])} found matching &quot;
        {inputValue}&quot;
      </div>
    );

  return (
    <>
      {filteredOptions.map((option) => {
        const isDisabled =
          disabledOptions.includes(option) || selectedOptions.includes(option);
        return (
          <OptionButton
            key={option}
            option={option}
            displayText={isStateMode ? getStateLabel(option) : undefined}
            isDisabled={isDisabled}
            onClick={() => !isDisabled && onOptionSelect(option)}
            optionsWithSegmentMap={optionsWithSegmentMap}
            segmentName={segmentName}
            isLastStep={isLastStep}
          />
        );
      })}
    </>
  );
};
